import uuid from 'react-uuid';

import LOG from '@graphql/mutations/log';

import { getGwUrl } from '@config/getEnviroment';
import { getAppKey, getDeviceKey } from '@utils/device';
import { getAppVersion, getOperationUuid } from '@utils/localStorage';
import { getSessionKey } from '@utils/session';

const url = getGwUrl() || '';

export const log = (input: any) => {
  if (url) {
    const device = getDeviceKey();
    const appVersion = getAppVersion();
    const appKey = getAppKey();
    const parsedVersion = appVersion ? appVersion.replaceAll('"', '') : appVersion;
    const operationId = getOperationUuid();
    const headers: any = {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'X-Device': device,
      'X-App': appKey,
      'X-Version': parsedVersion,
      'X-Correlation-ID': operationId || uuid(),
      'X-Session-ID': getSessionKey(),
    };
    /* eslint-disable */
    fetch(url, {
      method: 'POST',
      headers,
      body: JSON.stringify({
        query: LOG,
        variables: { input },
      }),
    });
    /* eslint-enable */
  }
};
